/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs */

const en_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyboard Shortcuts`)
};

const fr_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccourcis Clavier`)
};

const de_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tastenkombinationen`)
};

const it_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorciatoie da tastiera`)
};

const ru_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Клавиатурные сочетания`)
};

const es_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atajos de teclado`)
};

const zh_cn2_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`键盘快捷键`)
};

const ja_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーボードショートカット`)
};

const hi_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजीपटल अल्प मार्ग`)
};

const pt_pt2_toolbar_secondary_keyboard_shortcuts_title = /** @type {(inputs: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atalhos de teclado`)
};

/**
* | output |
* | --- |
* | "Keyboard Shortcuts" |
*
* @param {Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_keyboard_shortcuts_title = /** @type {((inputs?: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_keyboard_shortcuts_title(inputs)
	if (locale === "de") return de_toolbar_secondary_keyboard_shortcuts_title(inputs)
	if (locale === "it") return it_toolbar_secondary_keyboard_shortcuts_title(inputs)
	if (locale === "ru") return ru_toolbar_secondary_keyboard_shortcuts_title(inputs)
	if (locale === "es") return es_toolbar_secondary_keyboard_shortcuts_title(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_keyboard_shortcuts_title(inputs)
	if (locale === "ja") return ja_toolbar_secondary_keyboard_shortcuts_title(inputs)
	if (locale === "hi") return hi_toolbar_secondary_keyboard_shortcuts_title(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_keyboard_shortcuts_title(inputs)
	return en_toolbar_secondary_keyboard_shortcuts_title(inputs)
});